import Alpine from 'alpinejs';

Alpine.data('portfolioGrid', (totalItems) => ({
    activeItem: null,
    showPanelAfter: null,
    detailContent: '',
    columns: 3,
    totalItems: totalItems,

    init() {
        this.updateColumns();
        this._resizeHandler = () => {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => this.updateColumns(), 100);
        };
        window.addEventListener('resize', this._resizeHandler);
    },

    destroy() {
        window.removeEventListener('resize', this._resizeHandler);
    },

    updateColumns() {
        const width = window.innerWidth;
        if (width >= 1024) this.columns = 3;
        else if (width >= 640) this.columns = 2;
        else this.columns = 1;

        // Recalculate panel position if an item is active
        if (this.activeItem !== null) {
            this.showPanelAfter = this.getLastInRow(this.activeItem);
        }
    },

    getRow(index) {
        return Math.floor(index / this.columns);
    },

    getLastInRow(index) {
        const row = this.getRow(index);
        const lastInRow = Math.min((row + 1) * this.columns - 1, this.totalItems - 1);
        return lastInRow;
    },

    toggle(index) {
        if (this.activeItem === index) {
            this.close();
            return;
        }

        const newPanelAfter = this.getLastInRow(index);

        // Same row — just swap content instantly
        if (this.showPanelAfter === newPanelAfter) {
            const template = this.$refs[`detail-${index}`];
            if (template) this.detailContent = template.innerHTML;
            this.activeItem = index;
            return;
        }

        // Different row — fully close old panel first, then open new
        if (this.activeItem !== null) {
            this.activeItem = null;
            setTimeout(() => {
                this.showPanelAfter = null;
                this.detailContent = '';
                this.$nextTick(() => {
                    const template = this.$refs[`detail-${index}`];
                    if (template) this.detailContent = template.innerHTML;
                    this.showPanelAfter = newPanelAfter;
                    this.activeItem = index;
                    this.$nextTick(() => this.scrollToDetail());
                });
            }, 500);
        } else {
            const template = this.$refs[`detail-${index}`];
            if (template) this.detailContent = template.innerHTML;
            this.showPanelAfter = newPanelAfter;
            this.activeItem = index;
            this.$nextTick(() => this.scrollToDetail());
        }
    },

    close() {
        this.activeItem = null;
        setTimeout(() => {
            this.showPanelAfter = null;
            this.detailContent = '';
        }, 500);
    },

    scrollToDetail() {
        this.$nextTick(() => {
            const panel = this.$refs[`detailPanel${this.showPanelAfter}`];
            if (panel) {
                setTimeout(() => {
                    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }, 100);
            }
        });
    },
}));
